import { Option } from "../../../../../constants/common";

export const APPOINTMENT_MODE_FILTER_OPTIONS: Option[] = [
  { value: "Telehealth", label: "Telehealth" },
  { value: "In Person", label: "In Person" },
];

